/**
 * Environment Configuration
 * Validates and exports all required environment variables
 */

const requiredEnvVars = [
  'REACT_APP_RECAPTCHA_SITE_KEY',
  'REACT_APP_PUBLIC_KEY',
  'REACT_APP_API_URL'
];

const optionalEnvVars = ['REACT_APP_THANK_YOU_PAGE_URL', 'REACT_APP_ALLOWED_ORIGINS'];

// Validate required environment variables
requiredEnvVars.forEach((varName) => {
  if (!process.env[varName]) {
    throw new Error(
      `Missing required environment variable: ${varName}\n` +
        `Please check your .env file and ensure all required variables are set.\n` +
        `See .env.example for reference.`
    );
  }
});

// Validate public key format
const publicKey = process.env.REACT_APP_PUBLIC_KEY;
if (!publicKey.includes('-----BEGIN PGP PUBLIC KEY BLOCK-----')) {
  throw new Error(
    'REACT_APP_PUBLIC_KEY must be a valid PGP public key.\n' +
      'It should start with -----BEGIN PGP PUBLIC KEY BLOCK-----'
  );
}

// Export validated configuration
export const config = {
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  publicKey: process.env.REACT_APP_PUBLIC_KEY,
  apiUrl: process.env.REACT_APP_API_URL,
  thankYouPageUrl: process.env.REACT_APP_THANK_YOU_PAGE_URL,
  allowedOrigins: process.env.REACT_APP_ALLOWED_ORIGINS
    ? process.env.REACT_APP_ALLOWED_ORIGINS.split(',').map((origin) => origin.trim())
    : []
};

// Log configuration status in development
if (process.env.NODE_ENV === 'development') {
  console.log('Environment configuration loaded successfully');
  console.log('ReCAPTCHA configured:', !!config.recaptchaSiteKey);
  console.log('Public key configured:', !!config.publicKey);
  console.log('API URL configured:', !!config.apiUrl);
  console.log('Thank you page configured:', !!config.thankYouPageUrl || 'No redirect');
  console.log(
    'Allowed origins:',
    config.allowedOrigins.length > 0 ? config.allowedOrigins.join(', ') : 'All (development mode)'
  );
}

export default config;
